(function () {
    'use strict';

    angular.module('ecap.requestForProposal', []);
})();